import { FunctionComponent, ReactNode } from 'react';

import styles from './NavLeftTop.module.scss';

import Box from '../../Layout/Box/Box';

export type NavLeftTopProps = {
  label: string;
  description: string;
  children: ReactNode;
};

type FC = FunctionComponent<NavLeftTopProps>;

const NavLeftTop: FC = (props: NavLeftTopProps) => {
  const { label, description, children } = props;

  return (
    <Box pt="sm" ps="sm" pe="sm" flx="col" gap="md" height="auto">
      {children}
      <div className={styles.header}>{label}</div>
      <div className={styles.description}>{description}</div>
    </Box>
  );
};

export default NavLeftTop;
